// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-smallOnConfined-text-9d07005e"};